<div style="width: auto; overflow: auto">
    <app-common-list-table
        [showExportCsv]="false"
        [request]="getRequest" [filtering]="filter" [cols]="cols" [globalConditionalStyle]="globalConditionalStyle"
        [globalVisualTransform]="globalVisualTransform" [customExportCsv]="env.showTareasBioExportCsv"
        [actionButtonText]="env.canAddTareas ? btnAnadir : ''" (actionButtonClick)="add()"
        (visualize)="show('info', $event)" (edit)="edit($event)" (duplicate)="duplicate($event)"
        (remove)="show('delete', $event)">
        <ng-template #header>
            <div *ngIf="this.env.rol ==='responsable' || this.env.appName === 'benibal'" style="margin-left: 20px;">
                <button class="mx-2 btn" (click)="downloadCsv()"
                    style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white;">
                    <i class="fa fa-download"></i>
                    Exportar listado
                </button>
            </div>
        </ng-template>
        <ng-template #thEnd>
            <!-- <th [style.width]="showPrescripcion ? '150px' : ''"> -->
            <th class="rt-col-actions" style="width: 120px;">
                <p class="d-flex justify-content-center mb-0">Acciones</p>
            </th>
        </ng-template>


        <ng-template #tdEnd let-data>
            <td class="rt-col-actions">
                <div class="w-full d-flex justify-content-center align-items-center gap-4">
                    <app-action-buttons [hideDelete]="false" [showDuplicate]="env.canDuplicateTareas"
                        (duplicateRowButtonEvent)="duplicate(data.data)" (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)"
                        (showRowButtonEvent)="show('info', data.data)">
                    </app-action-buttons>
                </div>
            </td>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals [view]="this" [form]="form?.formFields" [serverUrl]="env.serverUrl" [previousData]="model"
    [recordHasAssociatedData]="false" [getRequest]="getRequest" [deleteRequest]="deleteRequest">
</app-modals>